const tools = [
    {
        pagePath: "/treatmentCalendar",
        title: '治疗日历',
        subtitle: "随时观察治疗进程",
        coverImage: require("@/assets/images/tool/tool_01.png")
    },
    {
        pagePath: "/tools",
        title: '工具箱',
        subtitle: "寻找工具更便捷",
        coverImage: require("@/assets/images/tool/tool_02.png")
    },
    {
        pagePath: "/countermeasureCard",
        title: '对策卡',
        subtitle: "在游戏中完成治疗",
        coverImage: require("@/assets/images/tool/tool_03.png")
    },
    {
        pagePath: "/scaleReportMain",
        title: '量表报告',
        subtitle: "展示你每次测试报告",
        coverImage: require("@/assets/images/tool/tool_04.png")
    }
]
export default {
    tools
}